import React, { useContext } from 'react';
import { DataContext } from '../context/DataContext';
import { useHistory } from 'react-router-dom';
import { toTitleCase } from '../util/titleCase';

const BillsCard = ({ arrayDataSets }) => {
  const dataContext = useContext(DataContext);
  const history = useHistory();

  const sendClicked = (subject) => {
    // console.log(subject, "subjectsubjectsubjectsubject");
    localStorage.setItem('clickedHomework', JSON.stringify(subject));
    dataContext.setHomework(subject);
    history.push('/viewHomework');
  };

  const transformedArray = arrayDataSets.map((entry) => ({
    name: Object.keys(entry)[0],
    ...entry[Object.keys(entry)[0]],
  }));

  // console.log(transformedArray);

  return (
    <>
      <div className='col-gap-6 px-4 mb-16'>
        {arrayDataSets && arrayDataSets.length === 0 ? (
          <div className='text-red-100 text-sm'>No bills availale here</div>
        ) : (
          arrayDataSets?.map((item, index) => (
            <div className='' key={index}>
              <div className='flex justify-between items-center mb-4'>
                <span className='text-gray-300 text-xs leading-4'>
                  {' '}
                  {Object.keys(item)[0]}{' '}
                </span>
              </div>
              {item[Object.keys(item)[0]].map((payment) => (
                <div className='bg-white p-4 mb-6 text-gray-100 mr-4 newNotesShadow'>
                  <div className='flex font-semibold  text-base '>
                    {payment.fee_type_name}
                  </div>
                  <div className='flex mx-auto font-medium text-sm mb-4'>
                    Oustanding NGN{' '}
                    {Number(payment.total_outstanding).toLocaleString()} <br />{' '}
                  </div>
                  <p>Discount: {payment.has_discount ? 'Yes' : 'No'}</p>
                  <div className='bg-blue-900 block mx-auto'>
                    {/* <div className="bg-blue-900 block mx-auto newHomeworkView"> */}
                    {/* <div className="bg-blue-900  "> */}
                    <a
                      // href= 'https://basic.edves.net/PayDirectPage1.php'
                      href={`${item.paymentLink}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer w-[200px]'
                    >
                      Make Payment
                    </a>
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default BillsCard;
